export default __webpack_public_path__ + "c03ed44da36753b1089f64cd25040e39.jpg";